module.exports = __webpack_public_path__ + "img/icon-ny-5.2d84967b.svg";